import { isNil } from 'lodash';
import React from 'react';
import { MBView } from '@shared/components/MBView';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBChatAttachmentProps } from '../index';
import { MBChatImageAttachment } from './index';

/*
    Wrapper around MBChatImageAttachment to show image preview when pressed
*/
export function MBChatImageAttachmentWithPreview({
  attachment,
  style,
  isSending,
  progress,
  onLongPress,
  forcedHeight,
  backgroundColor,
  onClick,
  containerWidth,
}: MBChatAttachmentProps) {
  return (
    <MBView
      style={[style, !isNil(forcedHeight) && { height: forcedHeight }, { backgroundColor }]}
      testID="MBChatImageAttachmentWithPreview"
    >
      <MBTouchableOpacity
        fill
        center={!isNil(forcedHeight)}
        disabled={isSending}
        activeOpacity={0.7}
        onPress={() => onClick?.(attachment)}
        onLongPress={onLongPress}
      >
        <MBChatImageAttachment
          attachment={attachment}
          isSending={isSending}
          progress={progress}
          forcedHeight={forcedHeight}
          backgroundColor={backgroundColor}
          containerWidth={containerWidth}
        />
      </MBTouchableOpacity>
    </MBView>
  );
}
